import { useEffect, useState } from "react";
import "./style.css";
import { useUserInfo } from "../../../../context/user";
import axios from "axios";
import DeleteFileModal from "../../../../components/DeleteFileModal";
import Uploadfile from "../../../../components/uploadFiles";
import AddWebsite from "../../../../components/addwebsites";
import AssistantMemory from "../../../../components/memory";
import env from "../../../../config/env"
import Icons from "../../../../components/icons";
import Plans from "../../../../components/Plans";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";
import { useUsersContext } from "../../../../context/usersContext";
import { Tooltip } from "@mui/material";
import { format } from "date-fns";

function DataInterpreter({ setActiveTab }) {
  const BASE_URL = env.API_URL + "/v1";
  const userInfo = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const [userFiles, setuserFiles] = useState();
  const [seletedFile, setSeletedFile] = useState();
  const [fileLoading, setFileLoading] = useState(false);
  const [memory, setMemory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [selectPlan, setSelectPlan] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [pagination, setPagination] = useState({})

  const getuploadfiles = async (page = 1) => {
    setFileLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/chat/get-data-interpreter-files?profile_id=${userActiveLocation?.id}&page=${page}&limit=${10}`,
      );
      if (response?.data?.data) {
        setuserFiles(response?.data?.data);
        setPagination(response?.data?.pagination)
      }
    } catch (error) {
      console.error("Error fetching files:", error);
    }
    setFileLoading(false);
  };

  useEffect(() => {
    getuploadfiles();
  }, []);

  const confirmDelete = (fileInfo) => {
    setSeletedFile(fileInfo);
  };

  const deleteFile = async (fileIdsToDelete) => {
    try {
      const idsToDelete = seletedFile ? [seletedFile?.id] : fileIdsToDelete;
      const agentIds = seletedFile && [seletedFile?.assistant_id];

      setFileLoading(true);

      for (const fileId of idsToDelete) {
        const response = await axios.post(
          `${BASE_URL}/chat/delete-interperter-file`,
          {
            file_id: fileId,
            assistant_ids: agentIds,
          }
        );

        if (response) {
          setuserFiles((prevFiles) =>
            prevFiles.filter((file) => file.id !== fileId)
          );
        }
      }

      setFileLoading(false);

      setSeletedFile();
      setSelectedItems([]);
    } catch (error) {
      alert(error.response?.data?.err || "An error occurred during deletion.");
      setFileLoading(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const filteredData = Array.isArray(userFiles)
    ? userFiles.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    : [];

  const totalPages = pagination.total || 0
  const maxButtonsToShow = 5;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = (searchQuery ? filteredFiles : filteredData)

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    if (pageNumber !== currentPage)
      getuploadfiles(pageNumber)
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      getuploadfiles(currentPage + 1)

    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      getuploadfiles(currentPage - 1)

    }
  };

  const startPage = Math.max(currentPage - Math.floor(maxButtonsToShow / 2), 1);
  const endPage = Math.min(startPage + maxButtonsToShow - 1, totalPages);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filtered = userFiles.filter((file) => {
      const fileName = file.name ? file.name.toLowerCase() : "";
      const fileUsername = file.username ? file.username.toLowerCase() : "";
      return fileName.includes(query) || fileUsername.includes(query);
    });

    setFilteredFiles(filtered);
    setCurrentPage(1);
  };

  return (
    <div className="container-alignment">
      <div className="MuiBox-root css-1wwy5nw">
        <h1 className="headingpage-branding">Data Interpreter</h1>
        <p className="pt-4 mb-3">
          Add example spreadsheets or CSVs your AI should analyse—ideal for
          reporting, audits, or structured data tasks.
        </p>
        <p className=" mb-4">
          For writing tasks or business knowledge,{" "}
          <span
            className="cursor-pointer"
            onClick={() => setActiveTab("Knowledge Base")}
          >
            use the Knowledge Base →
          </span>
        </p>
      </div>

      <>
        <div className="first_box relative">
          <div className="search_box">
            <input
              type="text"
              className={`inputsearch ${memory ? "!w-[500px]" : "!w-[740px]"} `}
              placeholder="Search for Files"
              value={searchQuery}
              onChange={handleSearch}
            />

            <span className="absolute top-3 left-3">
              <SearchIcon />
            </span>
          </div>

          <div style={{ display: "flex", width: "50%", justifyContent: "end" }}>
            <Uploadfile
              classname="filecogChatBtn"
              refreshchat={getuploadfiles}
              compType="data_interpreter"
            />
          </div>
        </div>
        <div>
          <table style={{ width: "100%" }}>
            <div className="table_heading">
              <p
                className="td_border"
                style={{ padding: "21px", width: "6%" }}
              ></p>
              <p
                className="td_border"
                style={{ padding: "21px", width: "20%" }}
              >
                File Name
              </p>

              <p
                className="td_border"
                style={{ padding: "21px", width: "20%" }}
              >
                Agents
              </p>

              <p
                className="td_border"
                style={{ padding: "21px", width: "20%" }}
              >
                Created
              </p>
              <p
                className="td_border"
                style={{ padding: "21px", width: "20%" }}
              >
                Added By
              </p>
              <p
                className="td_border"
                style={{ padding: "21px", width: "20%" }}
              ></p>
            </div>
            {fileLoading ? (
              <p align="center">Loading Files...</p>
            ) : (
              <>
                {(searchQuery ? filteredFiles : filteredData)?.length > 0 ? (
                  currentItems.map((item, index) => (
                    <div
                      key={index}
                      className="table_body"
                      style={{ background: "#FFFFFF" }}
                    >
                      <Tooltip title={item.name} placement="top-start">
                        <p
                          className="td_border truncate"
                          style={{ padding: "21px", width: "20%" }}
                        >
                          <span className="pr-2">
                            <Icons id="KBfile" />
                          </span>
                          {item.name}
                        </p>
                      </Tooltip>

                      <p
                        className="td_border"
                        style={{ padding: "21px", width: "20%" }}
                      >
                        {item.assistant_name?.replace("Your", "Brand")}
                      </p>

                      <p
                        className="td_border"
                        style={{ padding: "21px", width: "20%" }}
                      >
                        {format(new Date(item?.created_at), "dd/MM/yyyy")}
                      </p>
                      <p
                        className="td_border"
                        style={{ padding: "21px", width: "20%" }}
                      >
                        {item.username}
                      </p>
                      <p
                        className="td_border"
                        style={{
                          padding: "21px",
                          width: "20%",
                          paddingRight: "35px",
                          textAlign: "right",
                          display: "flex",
                          justifyContent: "right",
                          alignItems: "center",
                        }}
                      >
                        <button
                          onClick={() => confirmDelete(item)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <Icons id="delete" />
                        </button>
                      </p>
                    </div>
                  ))
                ) : (
                  <p align="center">No files found.</p>
                )}
              </>
            )}
          </table>
        </div>

        {/* Pagination Controls */}
        {!fileLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
              style={{
                padding: "8px 16px",
                margin: "0 5px",
                backgroundColor: "white",
                color: "black",
                border: "1px solid black",
                borderRadius: "4px",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                opacity: currentPage === 1 ? 0.6 : 1,
              }}
            >
              Previous
            </button>

            {[...Array(endPage - startPage + 1)].map((_, index) => {
              const pageNumber = startPage + index;
              return (
                <button
                  key={pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                  style={{
                    padding: "8px 16px",
                    margin: "0 5px",
                    backgroundColor:
                      pageNumber === currentPage ? "black" : "white",
                    color: pageNumber === currentPage ? "white" : "black",
                    border:
                      pageNumber === currentPage
                        ? "1px solid white"
                        : "1px solid black",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  {pageNumber}
                </button>
              );
            })}

            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              style={{
                padding: "8px 16px",
                margin: "0 5px",
                backgroundColor: "white",
                color: "black",
                border: "1px solid black",
                borderRadius: "4px",
                cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                opacity: currentPage === totalPages ? 0.6 : 1,
              }}
            >
              Next
            </button>
          </div>
        ) : (
          ""
        )}
      </>

      {selectPlan !== "" ? (
        <Plans
          justCloseIt={() => setSelectPlan(false)}
          isModalOpen={selectPlan ? true : false}
        />
      ) : (
        ""
      )}

      {seletedFile !== "" ? (
        <DeleteFileModal
          isModalOpen={seletedFile ? true : false}
          yesDelete={deleteFile}
          justCloseIt={() => {
            setSeletedFile(false);
          }}
          fileInfo={seletedFile}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default DataInterpreter;
